function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 39.5 39.5"
    },
    xmlSpace: "preserve",
    viewBox: "0 0 20 39.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "current",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 10,
    y1: 20,
    x2: 10,
    y2: 38
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "current"
    },
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(150,150,150)",
      strokeWidth: 0
    },
    opacity: 0.5,
    cx: 6,
    cy: 7,
    r: 2.5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.9998baa5a82646219411da9f5d432e5c.svg";
export { ForwardRef as ReactComponent };